import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./WorldMapSection.css";
import worldMap from "./assets/skc-world-map.png";
import carIcon from "./assets/animation-car.png";

gsap.registerPlugin(ScrollTrigger);

const WorldMapSection = () => {
  const sectionRef = useRef(null);
  const globeRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animate globe rotation
      gsap.to(globeRef.current, {
        rotation: 0,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
        ease: "none",
        duration: 20,
      });

      // Particle animation
      const particles = document.querySelectorAll(".particle");
      particles.forEach(particle => {
        gsap.to(particle, {
          y: -20,
          opacity: 0.7,
          duration: 2 + Math.random() * 2,
          repeat: -1,
          yoyo: true,
          ease: "sine.inOut",
          delay: Math.random() * 2
        });
      });

      // Car markers animation
      gsap.set(".car-marker", { autoAlpha: 0, scale: 0 });
      
      gsap.to(".car-marker", {
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 75%",
          end: "bottom 60%",
          scrub: true,
        },
        autoAlpha: 1,
        scale: 1,
        stagger: 0.2,
        duration: 1,
        ease: "back.out(1.7)",
      });

      // Content animation
      gsap.from(".content h2", {
        scrollTrigger: {
          trigger: ".content",
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
        y: 50,
        opacity: 0,
        duration: 1,
        ease: "power3.out",
      });

      gsap.from(".content p", {
        scrollTrigger: {
          trigger: ".content",
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
        y: 30,
        opacity: 0,
        duration: 1,
        delay: 0.3,
        ease: "power3.out",
      });

      // Continuous floating animation for cars
      const cars = document.querySelectorAll(".car-marker");
      cars.forEach(car => {
        gsap.to(car, {
          y: -15,
          duration: 2 + Math.random() * 1,
          repeat: -1,
          yoyo: true,
          ease: "sine.inOut",
          delay: Math.random() * 2
        });
      });

    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="worldmap-section" ref={sectionRef}>
      <div className="map-container">
        <div className="globe" ref={globeRef}>
          <img src={worldMap} alt="World Map" className="world-map" />
          
          {/* Animated particles */}
          {[...Array(15)].map((_, i) => (
            <div key={i} className="particle" style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              width: `${3 + Math.random() * 5}px`,
              height: `${3 + Math.random() * 5}px`,
            }}></div>
          ))}
        </div>

        <div className="content">
          <h2>About Us</h2>
          <p>
            We are a global automotive company with presence across multiple
            countries. Our mission is to connect customers with high-quality
            vehicles worldwide.
          </p>
        </div>

        {/* Car markers with improved styling */}
        <img src={carIcon} alt="Jamaica" className="car-marker car-jamaica" />
        <img src={carIcon} alt="Grenada" className="car-marker car-grenada" />
        <img src={carIcon} alt="Cayman" className="car-marker car-cayman" />
        <img src={carIcon} alt="Saint" className="car-marker car-saint" />
        <img src={carIcon} alt="Guyana" className="car-marker car-guyana" />
        <img src={carIcon} alt="Antigua" className="car-marker car-antigua" />
        <img src={carIcon} alt="Tanzania" className="car-marker car-tanzania" />
        <img src={carIcon} alt="Samoa" className="car-marker car-samoa" />
      </div>
    </section>
  );
};

export default WorldMapSection;